import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from '@lt/localization';
import { formatPhone } from '../../../../../../utils/stringUtils';

const baseCls = 'checkout-sidebar-client';

const Client = ({ name, phone, email, surname, onClick, isMobile }) => {
  const { t } = useTranslation();
  return (
    <div className={baseCls}>
      {!isMobile && (
        <div className="checkout-sidebar-top__label">
          {t('checkout.sidebar.client')}
        </div>
      )}

      <button
        className="checkout-sidebar-button"
        type="button"
        onClick={onClick}
      >
        <div className="like-h4">{`${name} ${surname}`}</div>

        {phone && (
          <div className="checkout-sidebar-top__text">{formatPhone(phone)}</div>
        )}

        <div className="checkout-sidebar-top__text">{email}</div>
      </button>
    </div>
  );
};

Client.defaultProps = {
  isMobile: false,
};

Client.propTypes = {
  name: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  surname: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

export default Client;
